import type { JSX, ReactNode } from 'react';
import { StrictMode } from 'react';

export const WistiaStrictMode = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}): JSX.Element => {
  if (process.env.REACT_STRICT_MODE === 'true') {
    return <StrictMode>{children}</StrictMode>;
  }

  /**
   * Fragment is needed here in case of multiple children
   */
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
